import { Button } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import React, { FC, useCallback } from 'react';
import { batch, useDispatch } from 'react-redux';

import { UI } from '../../../../../constants';
import { TLocalesKeys as K } from '../../../../../types';
import { useUserAction } from '../../../../common/hooks/useUserAction';
import { createBotTyping } from '../../../../common/messageCreators';
import { connectingAgent } from '../../../../common/messageCreators/connectingAgent';
import { chatSlice } from '../../../../common/reducers/chat';

export const DirectSupportButton: FC = React.memo(() => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const buttonLabel = t<K>('direct_support_request_btn_label');

  const emitDirectSupport = useUserAction(UI.DIRECT_SUPPORT_REQUESTED);
  const directSupportHandler = useCallback(() => {
    emitDirectSupport({ label: buttonLabel });
    batch(() => {
      dispatch(chatSlice.actions.addItem(connectingAgent()));
      dispatch(chatSlice.actions.startConnectingAgent());
      dispatch(chatSlice.actions.addItem(createBotTyping({ rm: true })));
    });
  }, [dispatch, emitDirectSupport, buttonLabel]);

  return (
    <Button priority="secondary" size="tiny" onClick={directSupportHandler}>
      {buttonLabel}
    </Button>
  );
});
